/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ProposAccueil.css';
import fetch from '../../core/fetch';
import { Link } from 'react-router';

@withStyles(s)
export default class ProposAccueil extends Component{
    
    constructor(props) {
        super(props);

        this.state = {
            slogans: []
        };

    }


    componentDidMount(){
        this.GetSlogans();
        
    }

    onItemClick(item, e) {  
        console.log(item.slug);
    }


    async GetSlogans(){

        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{slogans{id, slug, title, content, thumbnail, lien}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.slogans) throw new Error('Erreur sur le chargement des slogans !');

        this.setState({ slogans: data.slogans })
    }

    render(){

        var titreSection = "L'approche Prolifik";

        return (
            <div className={s.root}>
                <div className={`proposAccueil`}>
                    <div className={`container`}>
                        <div className={`wrapProposAccueil`}>
                            <div className={`left col-xs-12 col-md-5`}>
                                <div className={`content`}>
                                    <span className={`titreProposAccueil`}>{titreSection}</span>
                                    <div className={`texteProposAccueil`}>
                                        <p>{this.props.textePropos}</p>
                                    </div>
                                    <div className={`btnSite`}>
                                        <Link to="/approche">{this.props.ctaPropos}</Link>
                                    </div>
                                </div>
                            </div>
                            <div className={`right col-xs-12 col-md-7`}>
                                <div className={`content`}>
                                    <ul>
                                    {this.state.slogans.map((item, index) => (
                                        <li key={index} className={`col-md-4`}>
                                            <Link to={`/${item.lien}`}>
                                                <div className={`thumbIconService`}>
                                                    <img src={item.thumbnail} alt="image icone service" />
                                                </div>
                                                <span className={`titreService`}>{item.title}</span>
                                                <div className={`texteService`}>
                                                    <p>{item.content}</p>
                                                </div>
                                            </Link>
                                        </li>
                                    ))} 
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./components/ProposAccueil/ProposAccueil.js